import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { PhoneNumberBlock } from '@ratehub/base-ui';


function ProviderPhoneNumberBlock({
    phoneNumber,
    isPadded = false,
    ...otherProps
}) {
    return (
        <PhoneNumberBlock
            phoneNumber={phoneNumber}
            label={(
                <FormattedMessage
                    id="InsCommon.ProviderPhoneNumberBlock.label"
                    defaultMessage="Contact an expert"
                />
            )}
            showIcon={true}
            isPadded={isPadded}
            {...otherProps}
        />
    );
}

ProviderPhoneNumberBlock.propTypes = {
    phoneNumber: PropTypes.string.isRequired,
    isPadded: PropTypes.bool,
};

export default ProviderPhoneNumberBlock;